import {
  MessageRecord,
  MessageRecordPlaceholder, MessageRecordType,
} from '../../../../../../server-services/query-records/room-records';
import { ResponseMergerHandler } from '../../../cache-logic-interface';
import { messageIdStreamMerger } from './room-messages-by-id-query-merger';

export let customDialogueMessagesByIdQueryMerger: ResponseMergerHandler = function (
  cache,
  request,
  response: MessageRecord[]
) {
  if (response.length == 0) return;

  if (!cache.getCacheData('messages')[request.variables.peerId]) {
    cache.getCacheData('messages')[request.variables.peerId] = {};
  }

  response.forEach((msg) => {
    cache.getCacheData('messages')[request.variables.peerId][msg.id] = msg;

    const cacheKey = 'query.dialogueMessages.' + request.variables.peerId;
    let cachedMessages: (MessageRecordPlaceholder | MessageRecord)[] = cache.getCacheData(cacheKey);
    if (!cachedMessages?.length) {
      cachedMessages = [
        { type: MessageRecordType.END },
        { type: MessageRecordType.VOID },
        { type: MessageRecordType.END },
      ];
      cache.setCacheData(cacheKey, cachedMessages);
    }

    messageIdStreamMerger(cachedMessages, msg);
  });
};
